import React,{useState} from 'react'

export default function Form(props) {
    const [number, setNumber] = useState("")

    function onNumberChange(event){
        setNumber(event.target.value)
    }

    function onSubmit(event){
        event.preventDefault();
        props.onNumberSubmit(number)
    }

    return (
        <>
            <form className="form-inline mt-3 ml-3" onSubmit={onSubmit}>
                <label htmlFor="pokemon" className="mr-1">Number of pokemons:</label>
                <input className="form-control" onChange={onNumberChange} type="number" min="1" max="150" placeholder="6"></input>
                <input className="btn btn-primary ml-2" type="submit" value="Submit" />
            </form>
        </>
    )
}
